export default {
    translations: {
        'Inputs_Action_Copy_Clipboard': 'Copy to clipboard',
        /* PolicyCheck */
        'PolicyCheck_Text_1': 'I have read and agree to the',
        'PolicyCheck_Link_Privacy': 'privacy policy',
        'PolicyCheck_Text_2': '<br /> and ',
        'PolicyCheck_Link_Terms': 'terms of use',
        /* Configuration */
        'Configuration_Browser_Title': 'Alyze | General - Test Configuration',
        'Configuration_Title': 'Settings',
        'Configuration_Subtitle': 'You can setup certain aspects of your test like its language',
        'Configuration_Btn_Revert_Changes': 'Revert changes',
        'Configuration_Btn_Save_Changes': 'Save changes',
        'Configuration_Btn_Saved': 'Saved',
        'Configuration_Btn_Next_Step': 'Next step',
        'Configuration_Widget_Title_General': 'General',
        'Configuration_Input_Label_Name': 'Name',
        'Configuration_Input_Label_Audience_Limit': 'Audience limit',
        'Configuration_Input_Label_Language': 'Audience language',
        'Configuration_Input_Label_Custom_Campaign_Link': 'Custom Test Link',
        'Configuration_Input_Label_Schedule': 'Calendar',
        'Configuration_Input_Label_Starts': 'Start',
        'Configuration_Input_Label_Ends': 'End',
        'Configuration_Input_Label_Language_ES': 'Spanish',
        'Configuration_Input_Label_Language_EN': 'English',
        /* AgeRange */
        'AgeRange_Title': 'Age range',
        'AgeRange_Left_Legend': 'interactions',
        'AgeRange_Bottom_Legend': 'Age range',
        'AgeRange_Modal_Info_Title': 'Average age',
        'AgeRange_Modal_Info_Subtitle': 'Percentage of users by age range',
        /* Gender */
        'Gender_Title': 'Gender',
        'Gender_Bottom_Legend': 'interactions',
        'Gender_Left_Legend': 'gender identity range',
        'Gender_Male': 'Male',
        'Gender_Female': 'Female',
        'Gender_No_binaire': 'Prefer not to answer',
        'Gender_Modal_Info_Title': 'Top Gender',
        'Gender_Modal_Info_Subtitle': 'Percentage of users by gender',
        /* GlobalSummary */
        'GlobalSummary_Title': 'Global Summary',
        'GlobalSummary_Label_Interactions': 'Interactions',
        'GlobalSummary_Label_Users': 'Users',
        'GlobalSummary_Label_Top_Location': 'Top Location',
        'GlobalSummary_Label_Top_Genre': 'Top Genre',
        'GlobalSummary_Label_Average_Age': 'Average Age',
        'GlobalSummary_Label_Audience_Percentage': 'of your audience\'s age is between',
        /* MonthInteractions */
        'MonthInteractions_Title': 'Interactions in the last 30 days',
        'MonthInteractions_Bottom_Legend': 'days of month',
        'MonthInteractions_Left_Legend': 'interactions',
        /* TopLocations */
        'TopLocations_Title': 'Top Locations',
        'TopLocations_Left_Legend': 'interactions',
        'TopLocations_Bottom_Legend': 'Locations',
        'TopLocations_Modal_Info_Title': 'Top Locations',
        'TopLocations_Modal_Info_Subtitle': 'Percentage of users by city',
        /* WeekInteractions */
        'WeekInteractions_Title': 'Weekly Interactions',
        'WeekInteractions_Bottom_Legend': 'weekdays',
        'WeekInteractions_Left_Legend': 'interactions',
        /* Responses obtained */
        'Responses_Modal_Info_Title': 'Responses obtained',
        'Responses_Modal_Info_Subtitle': 'User interactions per week and per month',
        /* Metrics */
        'Metrics_Total_Activation': 'Total activation',
        'Metrics_Activation': 'Activation',
        'Metrics_Engagement': 'Engagement',
        'Metrics_Interest': 'Interest',
        'Metrics_Satisfaction': 'Satisfaction',
        'Metrics_Audio_Lowercase': 'audio',
        'Metrics_vídeo_Lowercase': 'video',
        'Metrics_Image_Lowercase': 'image',
        'Metrics_QA_Lowercase': 'Q&A',
        'Metrics_Audio_Capital_Letter': 'Audio',
        'Metrics_Video_Capital_Letter': 'Video',
        'Metrics_Large_Video_Capital_Letter': 'Film',
        'Metrics_Image_Capital_Letter': 'Image',
        'Metrics_QA_Capital_Letter': 'Q&A',
        'Metrics_All_Capital_Letter': 'All of them',
        'Metrics_Time_Point': 'time',
        'Metrics_Duration': 'duration',
        'Metrics_Legend_Time': 'time (seconds)',
        'Metrics_Legend_Answers': 'responses',
        'Metrics_Legend_Answered': 'answered',
        'Metrics_Cancel_Selection_Button': 'Cancel selection',
        'Metrics_Test_Without_Modules_Title': 'This test has no modules',
        'Metrics_Test_Without_Modules_Text': 'Please go to the "Design your test" section to start adding modules.',
        'Metrics_Test_Without_Modules_Link': 'Go to Design your test',
        'Metrics_Details_Emotions_Title': 'Emotions',
        'Metrics_Details_Emotions_Text': 'Here you can see the overall level of activation of each emotion generated by this content',
        'Metrics_Details_Activation_Title': 'Activation',
        'Metrics_Details_Activation_Text': 'Sum of all positive and negative emotions throughout your content',
        'MetricsModule_Score_Label_No_Results': 'No results',
        'MetricsModule_Score_Label_Poor': 'Poor',
        'MetricsModule_Score_Label_Regular': 'Regular',
        'MetricsModule_Score_Label_Good': 'Good',
        'MetricsModule_Score_Label_Very_Good': 'Very good',
        'MetricsModule_Score_Legend': 'Average score<br/>based on <b>[var1] responses</b>',
        'Metrics_Desktop_Promo_Title': 'Do you already know what Alyze can do?',
        'Metrics_Desktop_Promo_List1_Title': 'Customise your test completely',
        'Metrics_Desktop_Promo_List1_Text': 'You can add your logo and colours to your test as well as customize the introduction and end texts.',
        'Metrics_Desktop_Promo_List2_Title': 'Ask questions!',
        'Metrics_Desktop_Promo_List2_Text1': 'Add quizzes with questions and answers to your test.',
        'Metrics_Desktop_Promo_List2_Text2': 'Log in from a computer to use the <b>full version</b>',
        'Metrics_Share_Link_Title': 'Share link',
        'Metrics_Share_Link_Button_Copy': 'Copy',
        'Metrics_Share_Link_Text': 'This is the link to participate in your test, share it with whoever you want. The more people who complete the test, the more accurate your results will be.',
        'Metrics_Share_Link_Buy_Audience_Title': 'Choose your audience and we\'ll take care of everything for you',
        'Metrics_Share_Link_Buy_Audience_Button': 'Buy audience',
        /* AverageEmotions */
        'AverageEmotions_Emotion_Happiness': 'Happiness',
        'AverageEmotions_Emotion_Surprise': 'Surprise',
        'AverageEmotions_Emotion_Sadness': 'Sadness',
        'AverageEmotions_Emotion_Fear': 'Fear',
        'AverageEmotions_Emotion_Anger': 'Anger',
        'AverageEmotions_Emotion_Disgust': 'Disgust',
        /* EmotionalOverview */
        'EmotionalOverview_Title': 'Emotional summary',
        'EmotionalOverview_Bottom_Legend': 'time (seconds)',
        'EmotionalOverview_Left_Legend': 'emotional activation (%)',
        'EmotionalOverview_Total_Activation': 'Emotional summary',
        /* EmotionalPeaks */
        'EmotionalPeaks_Title': 'Emotional peak',
        'EmotionalPeaks_Emotion_Reached': 'emotion (% reached)',
        /* EngagementOverview */
        'EngagementOverview_Title': 'Engagement summary',
        'EngagementOverview_Left_Legend': 'engagement level (%)',
        /* InterestOverview */
        'InterestOverview_Title': 'Interest summary',
        'InterestOverview_Left_Legend': 'interest level (%)',
        /* MetricsPeaks */
        'MetricsPeaks_Title': 'Metric Peaks',
        'MetricsPeaks_Emotion_Reached': '% reached',
        /* MetricsSummary */
        'MetricsSummary_Title': 'Metrics summary',
        'MetricsSummary_Left_Legend': 'activation level (%)',
        /* SatisfactionOverview */
        'SatisfactionOverview_Title': 'Satisfaction summary',
        'SatisfactionOverview_Left_Legend': 'satisfaction level (%)',
        /* Panels */
        'Panels_Audio_Lowercase': 'audio',
        'Panels_vídeo_Lowercase': 'video',
        'Panels_Image_Lowercase': 'image',
        'Panels_QA_Lowercase': 'q&a',
        'Panels_Audio_Capital_Letter': 'Audio',
        'Panels_Video_Capital_Letter': 'Video',
        'Panels_Large_Video_Capital_Letter': 'Film',
        'Panels_Image_Capital_Letter': 'Imagen',
        'Panels_QA_Capital_Letter': 'Q&A',
        'Panels_Randomize_Order': 'Random order',
        'Panels_Play_Order': 'Play in order',
        'Panels_Show_Order': 'Show in order',
        'Panels_Technology': 'Technology',
        'Panels_Facial_Recognition': 'Facial recognition',
        'Panels_Choose_One': 'Choice',
        'Panels_Just_Play': 'Just play',
        'Panels_Landing_Title': 'Landing',
        'Panels_Introduction_Title': 'Introduction',
        'Panels_Finish_Title': 'Finalize',
        'Panels_Btn_Preview': 'Preview',
        /* ModuleTypeInfo */
        'ModuleTypeInfo_Recognition_Text': 'Analyze the user\'s face with our artificial intelligence and emotional recognition tool',
        'ModuleTypeInfo_Choose_Text': 'Forces the user to choose a single clip from all available clips',
        'ModuleTypeInfo_Play_Text': 'Play content without collecting facial recognition features',
        /* AddModulePanel */
        'AddModulePanel_Title': 'Add module',
        'AddModulePanel_Subtitle': 'Click or drag <br /> to add a new module',
        /* AudioModulePanel */
        'AudioModulePanel_Add_Audio_Button': 'Add audio',
        'AudioModulePanel_Audios': 'Audios',
        /* ImageModulePanel */
        'ImageModulePanel_Image_Duration': 'Image duration',
        'ImageModulePanel_Time': 'seconds',
        'ImageModulePanel_Add_Image_Button': 'Add image',
        'ImageModulePanel_Audios': 'Images',
        /* QAModulePanel */
        'QAModulePanel_Add_Question_Button': 'Add question',
        'QAModulePanel_Remove_Question_Button': 'Remove question',
        'QAModulePanel_Question': 'Question',
        'QAModulePanel_Write_Question': 'Write your question here...',
        'QAModulePanel_Answers': 'Answers',
        'QAModulePanel_Write_Answer': 'Write an answer here...',
        'QAModulePanel_Add_Answer_Button': 'Add answers',
        /* videoModulePanel */
        'VideoModulePanel_Add_Video_Button': 'Add video',
        'VideoModulePanel_Videos': 'videos',
        /* filmModulePanel */
        'FilmModulePanel_Add_Video_Button': 'Add film',
        'FilmModulePanel_Videos': 'Film file',
        'FilmModulePanel_Film_Name_Placeholder': 'Write the film name...',
        /* TextModulePanel */
        'TextModulePanel_Title': 'Title',
        'TextModulePanel_Text': 'Text',
        'TextModulePanel_Button': 'Button',
        /* PhonePreview */
        'PhonePreview_Press_Here_Text': 'Click here to<br/>to start the preview',
        /* PhonePreviewDesign */
        'PhonePreviewDesign_Title': 'Lorem Ipsum',
        'PhonePreviewDesign_Text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat',
        'PhonePreviewDesign_Button': 'Lorem Ipsum',
        /* CampaignsTable */
        'CampaignsTable_Column_1': 'Name',
        'CampaignsTable_Column_2': 'State',
        'CampaignsTable_Column_3': 'Responses',
        'CampaignsTable_Column_4': 'Analyzed',
        'CampaignsTable_Status_paid': 'Paid',
        'CampaignsTable_Status_draft': 'Draft',
        'CampaignsTable_Status_preview': 'Preview',
        'CampaignsTable_Status_inreview': 'In review',
        'CampaignsTable_Status_public': 'Public',
        'CampaignsTable_Status_processing': 'Processing',
        'CampaignsTable_Status_finished': 'Finished',
        'CampaignsTable_Status_finish': 'Finished',
        'CampaignsTable_Button_1_OnMouseOver': 'Copy Test link',
        'CampaignsTable_Button_2_OnMouseOver': 'View Test metrics',
        'CampaignsTable_Button_3_OnMouseOver': 'Edit Test',
        'CampaignsTable_Button_4_OnMouseOver': 'Clone Test',
        'CampaignsTable_Button_5_OnMouseOver': 'Delete Test',
        /* InputUploadFile_Upload_Image*/
        'InputUploadFile_Upload_Image': 'Change',
        /* Notifications */
        'Notifications_Changes_Applied': 'The changes have been saved correctly',
        'Notifications_Check_Data': 'Please review all the information before continuing',
        'Notifications_Incorrect_Email': 'The email you entered is incorrect',
        'Notifications_Conexion_Error': 'There is no Internet conection. Please try again in a few minutes',
        'Notifications_Unexpected_Error': 'Unexpected error. Please try again in a few minutes',
        'Notifications_Invalid_Code': 'Invalid access code',
        'Notifications_Session_Expired': 'The session has expired',
        'Notifications_Incorrect_Credentials': 'Incorrect email or password',
        'Notifications_Check_Email': 'Check your email to verify your account before logging in',
        'Notifications_Registered_Email': 'This email address is already registered',
        'Notifications_Link_Clipboard': 'Link copied to clipboard!',
        'Notifications_Account_Activated': 'Your account has been successfully activated!',
        'Notifications_Password_Updated': 'Your password has been updated correctly!',
        'Notifications_Check_Inbox': 'Please check your inbox to retrieve your password',
        'Notifications_Contact_ASAP': 'We will contact you shortly',
        'Notifications_Create_Account': 'Please create an account',
        'Notifications_Publish_Before_Proceed': 'You must publish your Test before continuing',
        'Notifications_Empty_Modules': 'One or more modules are empty',
        'Notifications_Video_Resolution': 'Video resolution must be less than 1280px',
        'Notifications_Video_Suggest_Compressor': 'We suggest you use a video compressor such as',
        'Notifications_Video_Compressor': 'convert-vídeo-online.com',
        'Notifications_Video_Duration': 'The length of the video must be less than 10 minutes',
        'Notifications_Video_Cutter': 'online-vídeo-cutter.com',
        'Notifications_Video_Size': 'Video size must be less than 200MB',
        'Notifications_Audio_Duration': 'The duration of the audio must be less than 5 minutes',
        'Notifications_Audio_Suggest_Compressor': 'We suggest you use an audio compressor such as ',
        'Notifications_Audio_Cutter': 'mp3cut.net',
        'Notifications_Audio_Compressor': 'online-audio-converter.com',
        'Notifications_Audio_Size': 'Audio size must be less than 10MB',
        'Notifications_Image_Resolution': 'Image resolution must be less than 1920px',
        'Notifications_Image_Suggest_Compressor': 'We suggest you use an image compressor such as ',
        'Notifications_Image_Compressor': 'resizeimage.net',
        'Notifications_Image_Size': 'Image size must be less than 1MB',
        'Notifications_Added_Credit': 'Credit has been added to your wallet',
        'Notifications_User_Exists': 'An account already exists with this email address. Enter your password to continue',
        'Notifications_BuyAudience_Payment_Succesfull': 'Your audience has been added',
        'Notifications_BuyAudience_Payment_Error': 'The payment could not be processed. Please try again in a few minutes',
        'Notifications_InviteAudience_Emails_Sent_Successfull': 'Emails have been sent correctly',
        'Notifications_Recopilator_Link_Deleted_Successfully': 'Link deleted successfully',
        'Notifications_Account_Deleted_Successfully': 'Your Alyze account has been deleted',
        /* Account */
        'Account_Browser_Title': 'Alyze | Account',
        'Account_Title': 'My account',
        'Account_Title_Plan_Details': 'Plan details',
        'Account_Title_Session_Details': 'Login details',
        'Account_Title_General_Options': 'General preferences',
        'Account_Input_Label_Name': 'Name',
        'Account_Input_Label_Username': 'Username',
        'Account_Input_Label_Password': 'Password',
        'Account_Input_Label_Email': 'Email',
        'Account_Input_Label_Language': 'Language',
        'Account_Button_Edit': 'Edit',
        'Account_General_Name': 'Name',
        'Account_General_Name_Modal_Title': 'Change your name',
        'Account_General_Name_Modal_Subtitle': 'We respect your privacy',
        'Account_General_Name_Modal_Cancel': 'Cancel',
        'Account_General_Name_Modal_Confirm': 'Rename',
        'Account_General_Lang': 'Language',
        'Account_General_Lang_Modal_Title': 'Change language',
        'Account_General_Lang_Modal_Subtitle': 'We respect your privacy',
        'Account_General_Lang_Modal_Cancel': 'Cancel',
        'Account_General_Lang_Modal_Confirm': 'Change language',
        'Account_General_Lang_ES': 'Spanish',
        'Account_General_Lang_EN': 'English',
        'Account_General_Username': "Username",
        'Account_General_Username_Modal_Title': 'Change your username',
        'Account_General_Username_Modal_Subtitle': 'We respect your privacy',
        'Account_General_Username_Modal_Cancel': 'Cancel',
        'Account_General_Username_Modal_Confirm': 'Confirm your username',
        'Account_Change_Password': 'Password',
        'Account_Change_Password_Subtitle': 'Change password',
        'Account_Change_Password_Current_Password': 'Current password',
        'Account_Change_Password_New_Password': 'New password',
        'Account_Change_Password_Retype_New_Password': 'Confirm the new password',
        'Account_Change_Password_Modal_Title': 'Change password',
        'Account_Change_Password_Modal_Subtitle': 'We respect your privacy',
        'Account_Change_Password_Modal_Cancel': 'Cancel',
        'Account_Change_Password_Modal_Confirm': 'Change password',
        'Account_DeleteAccount': 'Delete my account',
        'Account_DeleteAccount_Modal_Title': 'Delete my account',
        'Account_DeleteAccount_Modal_Subtitle': 'This action is <b>irreversible</b>',
        'Account_DeleteAccount_Modal_Content_Title': 'Are you sure you want to <b>permanently delete your account</b>?',
        'Account_DeleteAccount_Modal_Content_List_1': 'All your personal data will be deleted.',
        'Account_DeleteAccount_Modal_Content_List_2': 'You will lose all information related to your tests.',
        'Account_DeleteAccount_Modal_Content_List_3': 'You will no longer be able to access Alyze.',
        'Account_DeleteAccount_Modal_Content_List_4': 'This action cannot be undone.',
        'Account_DeleteAccount_Modal_Content_Label': 'Type <b>DELETE</b> to confirm',
        'Account_DeleteAccount_Modal_Cancel': 'Cancel',
        'Account_DeleteAccount_Modal_Confirm': 'Yes, delete my account',
        /* Campaigns */
        'Campaigns_Browser_Title': 'Alyze | Tests',
        'Campaigns_Title': 'Tests',
        'Campaigns_Review_Campaign_Text_1': 'Your Test "',
        'Campaigns_Review_Campaign_Text_2': '"will be reviewed by our team and published in a few minutes',
        'Campaigns_Close_Button': 'Close',
        'Campaigns_No_Campaigns_Found': 'You have no test!',
        'Campaigns_Start_First_Campaig': 'How about creating your first Test?',
        'Campaigns_New_Campaign_Button': 'Create Test',
        'Campaigns_Remove_Modal_Title': 'Delete test',
        'Campaigns_Remove_Modal_Subtitle': 'This action is <b>irreversible</b>',
        'Campaigns_Remove_Modal_Cancel': 'Cancel',
        'Campaigns_Remove_Modal_Confirm': 'Delete test',
        'Campaigns_Remove_Campaign_Text_1': 'Are you sure you want to delete <b>[var1]</b> permanently?',
        /* SupportAndHelp */
        'SupportAndHelp_Browser_Title': 'Alyze | Support & Help',
        'SupportAndHelp_Title': 'Support & Help',
        'SupportAndHelp_Tutorials': 'Tutorials',
        'SupportAndHelp_FAC': 'Frequent Questions',
        'SupportAndHelp_Contact': 'Contact us',
        'SupportAndHelp_Email': 'Email',
        'SupportAndHelp_Email_Address': 'support@byalyze.com',
        'SupportAndHelp_Realtime_Chat': 'Chat in real time',
        'SupportAndHelp_Open_Chat_Button': 'Open chat',
        /* CampaignsConfiguration */
        'CampaignsConfiguration_Revert_Changes_Button': "Revert changes",
        'CampaignsConfiguration_Saved_Button': "Saved",
        'CampaignsConfiguration_Save_Changes_Button': "Save changes",
        'CampaignsConfiguration_Back_Button': "Return",
        'CampaignsConfiguration_Next_Step_Button': "Following",
        /* Design */
        'Design_Browser_Title': 'Alyze | Test Configuration - Design',
        'Design_Title': 'EDIT THE APPEARANCE',
        'Design_Subtitle': 'You can customize your test with the style of your brand',
        'Design_Tab_Cover': 'COVER PAGE',
        'Design_Tab_General': 'GENERAL',
        'Design_General_Subtitle': 'General',
        'Design_Colors': 'Colors',
        'Design_Colors_Title': 'Títle',
        'Design_Text': 'Text',
        'Design_Background': 'Color',
        'Design_Logo': 'Logo',
        'Design_Dropdown_Image': 'Image',
        'Design_Dropdown_Text': 'Text',
        'Design_Dropdown_None': 'None',
        'Design_Dropdown_Solid': 'Solid',
        'Design_Dropdown_Border': 'Border',
        'Design_Background_Image': 'Background',
        'Design_Primary_Button': 'Buttons',
        'Design_Border_Radius': 'Corners',
        'Design_Secondary_Button': 'Secondary button',
        'Design_Landing_Subtitle': 'Landing',
        /* Metrics */
        'Metrics_Browser_Title': 'Alyze | Test Results - Metrics',
        'Metrics_Title': 'Metrics',
        'Metrics_Realtime_Stats': 'Real-time statistics',
        'Metrics_Realtime_Stats_Text': 'Click on the content to see<br/> real-time statistics',
        'Metrics_No_Results': 'No results yet!',
        'Metrics_No_Results_Text': 'The results of the metrics will be available<br /> when the Testers have completed your Test<br/>and their data has been processed',
        'Metrics_No_Results_Lite': 'No responses yet',
        'Metrics_No_Results_Text_Lite': 'To get your results, remember to share the link we have sent to your email. The more responses you get, the better results you will get!',
        /* Modules */
        'Modules_Click_To_Edit': 'Click here to edit',
        'Modules_Editing': 'Editing...',
        'Modules_Browser_Title': 'Alyze | Test Configuration - Modules',
        'Modules_Title': 'ADD MODULES',
        'Modules_Subtitle': 'Click or drag to add a new module',
        'Modules_Drag_To_Remove': 'Drag the module here to delete it',
        'Modules_Title_Finish': 'Finalize',
        'Modules_Title_Landing': 'Landing',
        'Modules_Title_Introduction': 'Introduction',
        'Modules_Title_Login': 'Login',
        'Modules_Save_Campaign_To_Preview_Modal_Title': 'Module preview',
        'Modules_Save_Campaign_To_Preview_Modal_Subtitle': 'Save and go to preview',
        'Modules_Save_Campaign_To_Preview_Modal_Cancel': 'Cancel',
        'Modules_Save_Campaign_To_Preview_Modal_Confirm': 'Save and preview',
        'Modules_Save_Campaign_To_Preview_Text': 'It is necessary to save the changes in order to preview the module.',
        'Modules_Max_Duration_Test_Modal_Title': 'Warning',
        'Modules_Max_Duration_Test_Modal_Subtitle': 'Maximum test duration reached',
        'Modules_Max_Duration_Test_Modal_Confirm': 'Continue editing',
        //'Modules_Max_Duration_Test_Text': 'You have exceeded the maximum time per test of your plan.<br/>Modify the duration of the modules to continue.<br/><br/>To increase your limit, upgrade your ',  
        'Modules_Max_Duration_Test_Text': 'You have exceeded the maximum time per test.<br/>Modify the duration of the modules to continue.',
        /* Preview */
        'Preview_Browser_Title': 'Alyze | Preview',
        'Preview_Title': 'PREVIEW',
        'Preview_Subtitle': 'You can test and share a preview of the test before publishing it',
        'Preview_Try_Test_Title': 'Check your test',
        'Preview_Try_Test_Text': 'Check your test exactly the way your users will see it',
        'Preview_Try_Test_CTA': 'See my test',
        'Preview_Publish_Title': 'Publish the preview',
        'Preview_Publish_Text_A': 'Activate this option to share the preview with whoever you want',
        'Preview_Publish_Text_B': 'Deactivate it at any time and no one will have access to the link',
        'Preview_Share_Title': 'Share the preview',
        'Preview_Share_CTA': 'Copy link',
        'Preview_Share_Text': '<b>Copy and send the link to whoever you want</b> and they will have access to the preview as long as you keep it published',
        /* Recopilator */
        'Recopilator_Browser_Title': 'Alyze | Response Collectors',
        'Recopilator_GlobalSummary_Title': 'Global Summary',
        'Recopilator_Links_Title': 'Send surveys your way',
        'Recopilator_Links_Text': 'Send your surveys by email, insert them on your website, share a link on your social networks or a web page, among many more options',
        'Recopilator_Links_Add': 'Add your own audience',
        'Recopilator_Links_Copy': 'Copy',
        'Recopilator_Links_Toggle': 'Active',
        'Recopilator_Links_Paid_Title': 'Focus on the right people for your survey',
        'Recopilator_Links_Paid_Text': 'Buy responses from the demographic groups that really matter to you in our global survey panel: Alyze Audience. Get results in minutes.',
        'Recopilator_Links_Paid_Add': 'Buy audience',
        'Recopilator_Links_Paid_Button': 'View features',
        'Recopilator_Links_Paid_Location': 'Location',
        'Recopilator_Links_Paid_Genre': 'Gender',
        'Recopilator_Links_Paid_Age': 'Age',
        'Recopilator_Metrics_Responses': 'Responses obtained',
        'Recopilator_Metrics_Location': 'Top Location',
        'Recopilator_Metrics_Genre': 'Top Gender',
        'Recopilator_Metrics_Age': 'Average age',
        'Recopilator_Edit_Link_Modal_Title': 'Edit link',
        'Recopilator_Edit_Link_Modal_Subtitle': 'The alias will help you better identify your audience',
        'Recopilator_Edit_Link_Modal_Cancel': 'Cancel',
        'Recopilator_Edit_Link_Modal_Confirm': 'Save changes',
        'Recopilator_Edit_Link_Input_Name': 'Alias',
        'Recopilator_Add_Link_Modal_Title': 'Add link',
        'Recopilator_Add_Link_Modal_Subtitle': 'Add as many links as you need to segment your audience',
        'Recopilator_Add_Link_Modal_Cancel': 'Cancel',
        'Recopilator_Add_Link_Modal_Confirm': 'Add link',
        'Recopilator_Add_Link_Input_Name': 'Alias',
        'Recopilator_Delete_Link_Modal_Title': 'Delete link',
        'Recopilator_Delete_Link_Modal_Subtitle': 'You are about to remove a link',
        'Recopilator_Delete_Link_Modal_Text_1': '<b>Warning:</b> this link already has responses.',
        'Recopilator_Delete_Link_Modal_Text_2': 'By deleting the link, you\'ll lose all responses associated with it.',
        'Recopilator_Delete_Link_Modal_Text_3': 'It will no longer be possible to access the test from this link.',
        'Recopilator_Delete_Link_Modal_Text_4': 'Are you sure you want to delete <b>[var1]</b>?',
        'Recopilator_Delete_Link_Modal_Cancel': 'No, cancel',
        'Recopilator_Delete_Link_Modal_Confirm': 'Yes, delete',
        /*
        'Recopilator_User_Max_Tests_Reached_Modal_Title': 'Extend your plan to continue',
        'Recopilator_User_Max_Tests_Reached_Modal_Subtitle': 'You have exceeded this month\'s test limit',
        'Recopilator_User_Max_Tests_Reached_Modal_Cancel': 'Close',
        'Recopilator_User_Max_Tests_Reached_Modal_Confirm': 'View plans',
        'Recopilator_User_Max_Tests_Reached_Modal_Text_1': 'Your [var1] plan allows you to publish up to [var2] tests per month.',
        'Recopilator_User_Max_Tests_Reached_Modal_Text_2': 'To publish this test you must wait for the monthly period to renew or upgrade your account to a higher plan.',
        */
        'Recopilator_User_Max_Tests_Reached_Modal_Title': 'Limit reached',
        'Recopilator_User_Max_Tests_Reached_Modal_Subtitle': 'You have exceeded this month\'s test limit',
        'Recopilator_User_Max_Tests_Reached_Modal_Confirm': 'Ok',
        'Recopilator_User_Max_Tests_Reached_Modal_Text_1': 'You have reached the maximum number of monthly tests.',
        'Recopilator_User_Max_Tests_Reached_Modal_Text_2': 'To publish this test you must wait for the monthly period.',
        /* Buy audience */
        'BuyAudience_Go_Back': 'Back to test collectors',
        'BuyAudience_Title': 'Payment audience',
        'BuyAudience_Description': 'Don\'t have your own list of potential respondents? Alyze Audience allows you to send your test to the right people. Choose your audience below to get a cost estimate. We will send your test to the people in our global panel who match your criteria.',
        'BuyAudience_Step1_Title': 'STEP 1: Who do you want answers from?',
        'BuyAudience_Step1_Description': 'Alyze is based on reliable, high quality data.',
        'BuyAudience_Step1_Link': 'Find out how the quality of our data helps you succeed.',
        'BuyAudience_Step1_Location_Title': 'Location',
        'BuyAudience_Step1_Location_Text': 'Location',
        'BuyAudience_Step1_Location_Text_All': 'All',
        'BuyAudience_Step1_Genre_Title': 'Genre',
        'BuyAudience_Step1_Genre_Text': 'Gender',
        'BuyAudience_Step1_Genre_Text_Male': 'Man',
        'BuyAudience_Step1_Genre_Text_Female': 'Woman',
        'BuyAudience_Step1_Genre_Text_Both': 'Both',
        'BuyAudience_Step1_Age_Title': 'Age',
        'BuyAudience_Step1_Age_Text': 'Age',
        'BuyAudience_Step2_Title': 'STEP 2: How many complete answers do you need?',
        'BuyAudience_Step2_Description': 'Margin of error ≤ 4%',
        'BuyAudience_Total_Cost_Title': 'Total cost',
        'BuyAudience_Total_Cost_Tax': 'VAT included',
        'BuyAudience_Total_Cost_Responses': 'Answers to be paid',
        'BuyAudience_Total_Cost_Responses_Total': 'Total answers',
        'BuyAudience_Total_Cost_Price': 'Price per response',
        'BuyAudience_Total_Cost_Duration': 'Test duration',
        'BuyAudience_Total_Cost_Rules': 'Segmentation rules',
        'BuyAudience_Total_Cost_Button': 'Go to payment',
        'BuyAudience_Promo': 'Promotion',
        'BuyAudience_Promo_Name': 'Promotion [var1]',
        'BuyAudience_Promo_Text': 'x2 (FREE)',
        'BuyAudience_Promo_Description': 'get double of answers you have selected for free.',
        'BuyAudience_Custom_Segments': 'If you need a more customized segmentation, ',
        'BuyAudience_Custom_Segments_Link': 'you can contact us.',
        /* Invite audience */
        'InviteAudience_Title': 'Send your test to whoever you want',
        'InviteAudience_Description': 'Add the email addresses of the people you want to send the test to.<br/> A unique link will be generated for each person, and an email will be sent to them with the link to participate in the test.',
        'InviteAudience_Button_Add': 'Invite users',
        'InviteAudience_Button_Reactivate': 'Resend',
        'InviteAudience_Table_Column1': 'Email',
        'InviteAudience_Table_Column2': 'Status',
        'InviteAudience_Table_Column3': 'Enabled',
        'InviteAudience_Table_Date': 'Sent on [var1]',
        'InviteAudience_Table_Status_Finished': 'Finished',
        'InviteAudience_Table_Status_Sent': 'Sent',
        'InviteAudience_Table_Status_Started': 'Started',
        'InviteAudience_Table_Loading_Resending': 'Resending email...',
        'InviteAudience_Table_Loading_Enabling': 'Enabling link...',
        'InviteAudience_Table_Loading_Disabling': 'Disabling link... ',
        'InviteAudience_Modal_Title': 'Invite users to the test',
        'InviteAudience_Modal_Subtitle': 'Add as many email addresses as you want.',
        'InviteAudience_Modal_Input_Label_Email': 'Email',
        'InviteAudience_Modal_Button_Add_Email': 'Add another email',
        'InviteAudience_Modal_Confirm': 'Invite audience',
        /* Status */
        'Status_Browser_Title': 'Alyze | Test Results - Audience',
        'Status_Title': 'Audience',
        'Status_No_Audience': 'This Test does not yet have <br/> audience results',
        /* Login */
        'Login_Browser_Title': 'Alyze | Log in',
        'Login_Email': 'Email',
        'Login_Email_Placeholder': 'Write your email',
        'Login_Password': 'Password',
        'Login_Password_Placeholder': 'Enter your password',
        'Login_Log_In_Button': 'Log in',
        'Login_Forgotten_Password': 'Have you forgotten your password?',
        'Login_Dont_Have_Account': 'Don\'t you have an account yet?',
        'Login_Register_Button': 'REGISTER HERE',
        /* RememberPassword */
        'RememberPassword_Browser_Title': 'Alyze | Login',
        'RememberPassword_Title': 'Have you forgotten your password?',
        'RememberPassword_Send_Email_Button': 'Send',
        'RememberPassword_Back_To_Login_Button': 'Back to login',
        /* Singup */
        'Singup_Browser_Title': 'Alyze | Sign up',
        'Singup_Title': 'Create new account',
        'Singup_Name': 'Full name',
        'Singup_Name_Placeholder': 'Write your full name',
        'Singup_Code': 'Promotional Code (Optional)',
        'Singup_Code_Placeholder': '0000-0000-0000',
        'Singup_Create_Account_Button': 'CREATE NEW ACCOUNT',
        'Singup_Password': 'Password',
        'Singup_Password_Placeholder': 'Create your password',
        /* SingupConfirm */
        'SingupConfirm_Browser_Title': 'Alyze | Sign up confirmation',
        'SingupConfirm_Title': 'Activate your account!',
        'SingupConfirm_Text': 'Check your inbox to <br/><b>activate your account</b>',
        /* SubscriptionWidget */
        'SubscriptionWidget_Plan_Type': 'Plan type',
        'SubscriptionWidget_Plan_Usage': 'Plan usage',
        'SubscriptionWidget_Consumed_Tests': '<b>[var1]</b> / [var2] this month',
        'SubscriptionWidget_Btn_Subscribe_Plan': 'Upgrade plan',
        'SubscriptionWidget_Btn_Change_Plan': 'Change plan',
        'SubscriptionWidget_Yearly': 'Annual',
        'SubscriptionWidget_Montly': 'Monthly',
        'SubscriptionWidget_Tests_Number': 'tests',
        'SubscriptionWidget_Tests_Unlimited': 'UNLIMITED Tests',
        'SubscriptionWidget_Plan_Renovation': '[var1] will be restored',
        'SubscriptionWidget_Plan_Info_Renovation': 'Your subscription [var1] will be automatically renewed [var2]',
        'SubscriptionWidget_Plan_Info_Ends': 'Your subscription [var1] will end [var2]',
        'SubscriptionWidget_Legend_Tests': 'Tests',
        /* SubscriptionPlan */
        'SubscriptionPlan_Featured_Badged': 'THE MOST POPULAR',
        'SubscriptionPlan_Price_Month': '/ MONTH',
        'SubscriptionPlan_Description': 'Publish <b>[var1] test</b> of up to <b>[var2] minutes</b> every month',
        'SubscriptionPlan_Description_Unlimited': 'Publish <b>all the tests you need</b> up to <b>[var1] minutes</b>',
        'SubscriptionPlan_Active_From': 'Active subscription<br/>since [var1]',
        'SubscriptionPlan_Active_To': 'Your subscription<br/>will end on [var1]',
        'SubscriptionPlan_Pay_Yearly': 'Annual payment',
        'SubscriptionPlan_Pay_Montly': 'Monthly payment',
        'SubscriptionPlan_Btn_Change_Plan': 'Change to [var1]',
        'SubscriptionPlan_Characteristics': '<p>Test up to <b>[var1] minutes</b></p>',
        'SubscriptionPlan_Montly_Tests': '<p><b>[var1] Tests</b> per month</p>',
        'SubscriptionPlan_Unlimited_Tests': '<p><b>UNLIMITED Tests </b></p>',
        'SubscriptionPlan_Btn_More_Details': ' See details',
        'SubscriptionPlan_Title': 'Choose your plan',
        'SubscriptionPlan_Subtitle_1': 'We offer you different plans so that you can choose the one that best suits your needs',
        'SubscriptionPlan_Subtitle_2': 'You can change it at any time',
        'SubscriptionPlan_Custom_Name': 'custom',
        'SubscriptionPlan_Custom_Description': 'Do you need a custom service?',
        'SubscriptionPlan_Btn_Contact': 'Contact',
        'SubscriptionPlan_Downgrade_Modal_Title': 'Cancel subscription',
        'SubscriptionPlan_Downgrade_Modal_Subtitle': 'Your current subscription will remain active for the paid period',
        'SubscriptionPlan_Downgrade_Text': 'Are you sure you want to cancel your subscription?',
        'SubscriptionPlan_Downgrade_Modal_Cancel': 'Cancel',
        'SubscriptionPlan_Downgrade_Modal_Confirm': 'Confirm',
        'SubscriptionPlan_Facturation_Montly': 'Monthly billing',
        'SubscriptionPlan_Facturation_Yearly': 'Annual billing',
        'SubscriptionPlan_Yearly_Discount': 'Save 16%',
        /* TopBar */
        'TopBar_My_Tests': 'My tests',
        'TopBar_Plans_And_Prices': 'Plans and prices',
        'TopBar_Change_Plan': 'Upgrade plan',
        'TopBar_Create_Test': 'Create test',
        'TopBar_Submenu_My_Account': 'My account',
        'TopBar_Submenu_Support_And_Help': 'Support and help',
        'TopBar_Submenu_Close_Session': 'Sign out',
        'TopBar_Add_New_Modal_Title': 'Create new test',
        'TopBar_Add_New_Modal_Subtitle': 'You can change these options later',
        'TopBar_Add_New_Modal_Cancel': 'Cancel',
        'TopBar_Add_New_Modal_Confirm': 'Create test',
        'TopBar_Add_New_Input_Name': 'Name',
        'TopBar_Add_New_Input_Lang': 'Audience language',
        'TopBar_Add_New_Input_Type': 'Test type',
        'TopBar_Add_New_Select_Type_Generic': 'Generic',
        'TopBar_Add_New_Select_Type_Film': 'Film',
        /* DurationBar */
        'DurationBar_Title': 'Duration',
        'DurationBar_Legend_Included': 'Included in your plan',
        'DurationBar_Legend_Non_Included': 'Not included in your plan',
         /* ContentHeader */
        'ContentHeader_Account': 'Account summary',
        'ContentHeader_Support_And_Help': 'Support and help',
        'ContentHeader_Design_Test': 'Design your test',
        'ContentHeader_Preview_And_Share': 'Generate a preview and share it',
        'ContentHeader_Get_Responses': 'Collect responses',
        'ContentHeader_Invite_Audience': 'Invite audience',
        'ContentHeader_Get_Results': 'Get the results',
        'ContentHeader_Saved_Button': "Saved",
        'ContentHeader_Save_Changes_Button': "Save Changes",
        'ContentHeader_Version_Control_Tooltip': 'Show version history',
        'ContentHeader_Enable_Demo': 'Enable demo',
        /* Version control */
        'VersionControl_Title': 'Version history',
        'VersionControl_Version_Name': 'Version',
        'VersionControl_Versions_Empty': 'No version history yet',
        /* Save_Published_Campaign */
        'Save_Published_Campaign_Modal_Title': 'Edit a published test?',
        'Save_Published_Campaign_Modal_Subtitle': 'This test is already getting results',
        'Save_Published_Campaign_Modal_Cancel': 'No, cancel',
        'Save_Published_Campaign_Modal_Confirm': 'Yes, edit',
        'Save_Published_Campaign_Text': '<b>Warning:</b> you are editing one or more modules that already have answers.',
        'Save_Published_Campaign_Text_Error_Title': 'Editing a module',
        'Save_Published_Campaign_Text_Error': 'When you edit the content of a module, you will lose all the answers associated with it.',
        'Save_Published_Campaign_Text_Warning_Title': 'Reordering content',
        'Save_Published_Campaign_Text_Warning': 'If you change the order of the modules or stimuli you will not lose your answers, but it may alter the results.',
        'Save_Published_Campaign_Text_Ok_Title': 'Editing the appearance',
        'Save_Published_Campaign_Text_Ok': 'You can change the texts on the landing, introduction and finalize screens, as well as the appearance of your test without affecting your answers.',
        'Save_Styles_Published_Campaign_Modal_Title': 'Change the appearance of the test',
        'Save_Styles_Published_Campaign_Modal_Subtitle': 'This test is already getting results',
        'Save_Styles_Published_Campaign_Modal_Cancel': 'Cancel',
        'Save_Styles_Published_Campaign_Modal_Confirm': 'Save changes',
        'Save_Styles_Published_Campaign_Text':'These changes will not affect the results obtained.',
        /* Save_Published_Campaign */
        'Lite_User_Email_Modal_Title': '¡Just a moment!',
        'Lite_User_Email_Modal_Subtitle': 'To save your results, we need an email address. (We will send you your password there in order to view your results)',
        'Lite_User_Email_Modal_Confirm': 'Save',
        'Lite_User_Email_Input_Email': 'Email',
        'Lite_User_Email_Input_Email_Placeholder': 'Enter your email',
        'Lite_User_Email_Input_Password': 'Password',
        'Lite_User_Email_Input_Password_Placeholder': 'Enter your password',
        'Lite_File_Browser_Title': 'Alyze Wizard | Select the content',
        'Lite_Link_Browser_Title': 'Alyze Wizard | Share the test',
        'Lite_Metrics_Browser_Title': 'Alyze Wizard | View results',
        'Lite_User_Login_Modal_Title': 'Enter your password',
        'Lite_User_Login_Modal_Subtitle': 'Enter your password to view your test results',
        'Lite_User_Login_Modal_Confirm': 'View results',
        'Lite_Test_Edit_Modal_Title': 'Editar test',
        'Lite_Test_Edit_Modal_Subtitle': 'Pon un título identificativo a tu test',
        'Lite_Test_Edit_Modal_Confirm': 'Guardar',
        'Lite_Test_Edit_Modal_Cancel': 'Cancelar',
        'Lite_Test_Edit_Modal_Input_Name': 'Título',
        'Lite_Test_Edit_Modal_Input_Name_Placeholder': 'Introduce un título ...',
        /*
        'Lite_User_Max_Tests_Reached_Modal_Title': 'Extend your plan to continue',
        'Lite_User_Max_Tests_Reached_Modal_Subtitle': 'You have exceeded this month\'s test limit',
        'Lite_User_Max_Tests_Reached_Modal_Confirm': 'Ok',
        'Lite_User_Max_Tests_Reached_Modal_Text_1': 'Your [var1] plan allows you to publish up to [var2] tests per month.',
        'Lite_User_Max_Tests_Reached_Modal_Text_2': 'To publish this test you must wait for the monthly period to renew or upgrade your account to a higher plan.'
        */
        'Lite_User_Max_Tests_Reached_Modal_Title': 'Limit reached',
        'Lite_User_Max_Tests_Reached_Modal_Subtitle': 'You have exceeded this month\'s test limit',
        'Lite_User_Max_Tests_Reached_Modal_Confirm': 'Ok',
        'Lite_User_Max_Tests_Reached_Modal_Text_1': 'You have reached the maximum number of monthly tests.',
        'Lite_User_Max_Tests_Reached_Modal_Text_2': 'To publish this test you must wait for the monthly period.',
    }
}